<template>
    <div class="row left-content">
        <b-card
            v-if="drivers"
            title="Drivers"
        >
            <div>
                <b-form inline>
                    <b-form-input
                        v-model="form.id"
                        type="text"
                        placeholder="ID"
                    ></b-form-input>
                    <b-form-select
                        v-model="form.project"
                        :options="projects"
                    >
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Project</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-input
                        v-model="form.firstName"
                        type="text"
                        placeholder="First Name"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.lastName"
                        type="text"
                        placeholder="Last Name"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder="Email"
                    ></b-form-input>

                    <b-button variant="primary" type="submit" @click.prevent.stop="search">Search</b-button>
                </b-form>
            </div>
            <table class="table table-bordered table-striped mt-4">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Project</th>
                    <th>Created At</th>
                    <th>Name</th>
                    <th>DL Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="driver in drivers" :key="driver.id">
                    <td>
                        <router-link :to="{name: 'admin.driver.view', params: { id: driver.id }}">
                            {{ driver.id }}
                        </router-link>
                    </td>
                    <td>{{ driver.project_title }}</td>
                    <td>{{ formatedDate(driver.date) }}</td>
                    <td>{{ driver.name + '(' + driver.email + ')' }}</td>
                    <td>
                        <b-badge variant="secondary" v-if="!driver.photo">Not uploaded</b-badge>
                        <b-badge variant="success" v-else-if="driver.is_approved">Approved</b-badge>
                        <b-badge variant="danger" v-else>Not Approved</b-badge>
                    </td>
                </tr>
                </tbody>
            </table>
            <b-pagination
                v-if="paginator.total / paginator.perPage > 1"
                :value="page"
                :total-rows="paginator.total"
                :per-page="paginator.perPage"
                @change="change($event)"
            ></b-pagination>
        </b-card>

    </div>
</template>

<script>
export default {
    name: "List",
    props: {
        'page': {
            'default': 1
        }
    },
    data() {
        return {
            drivers: [],
            paginator: [],
            form: {
                email: null,
                firstName: null,
                lastName: null,
                id: null,
                project: null
            }
        }
    },
    computed: {
        projects() {
            return this.$store.state.projects;
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.$router.push({ name: 'admin.driver', params: { page: event } });
            this.getDrivers(event);
        },
        getDrivers(page) {
            window.axios.get('/admin/driver/index', {params: {...{page: page}, ...this.form}})
                .then(response => {
                        this.drivers = response.data.drivers;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
        search() {
            this.getDrivers(this.page);
        }
    },
    mounted() {
        this.getDrivers(this.page);
        this.$store.dispatch('getProjectsList');
    }
}
</script>